import Vue from "vue";
import { checkMenuAccess } from "./accessControl";

Vue.directive("access", {
  inserted(el, binding, vnode) {
    // get the Vue instance from the parent context
    const vm = vnode.context;

    if (!vm || typeof vm.getCurrentUser !== "function") {
      console.warn("[v-access] Missing getCurrentUser method in component.");
      el.style.display = "none";
      return;
    }

    const currentUser = vm.getCurrentUser();
    const rules = binding.value || {};

    const hasAccess = checkMenuAccess(rules, currentUser);

    if (!hasAccess) {
      el.style.display = "none";
    }
  },
});
